var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { getTrackerProps } from '../../common/tracking/getTrackerProps';
import { color } from '../../common/theme/helper';
import { NavigationLine, NavigationLink } from './NavigationList';
var LanguageSwitchContainer = styled(NavigationLine)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-shadow: inset 0 -1px 0 ", ",\n    inset 0 1px 0 ", ";\n"], ["\n  box-shadow: inset 0 -1px 0 ", ",\n    inset 0 1px 0 ", ";\n"])), color('gray', 4), color('gray', 4));
var LanguageSelector = styled(NavigationLink)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  justify-content: center;\n  width: ", "%;\n  align-self: stretch;\n  font-weight: ", ";\n  cursor: pointer;\n  &:last-of-type {\n    box-shadow: inset 1px 0 0 ", ";\n  }\n"], ["\n  justify-content: center;\n  width: ", "%;\n  align-self: stretch;\n  font-weight: ", ";\n  cursor: pointer;\n  &:last-of-type {\n    box-shadow: inset 1px 0 0 ", ";\n  }\n"])), function (props) { return props.width; }, function (props) { return (props.current ? 'bold' : 'normal'); }, color('gray', 4));
var LanguageSwitch = function (_a) {
    var languages = _a.languages;
    return languages && languages.length > 1 ? (React.createElement(LanguageSwitchContainer, null, languages.map(function (_a) {
        var language = _a.language, isCurrent = _a.isCurrent, pathPrefix = _a.pathPrefix;
        return (React.createElement(LanguageSelector, __assign({ key: language }, getTrackerProps({
            href: pathPrefix + "/",
            current: isCurrent,
            width: 100 / languages.length,
        }, {
            event: 'headerTracking',
            eventData: {
                placement: 'slidingMenu',
                label: language,
                labelIdentifier: 'languageSelector',
            },
        })), language));
    }))) : null;
};
LanguageSwitch.propTypes = {
    languages: PropTypes.arrayOf(PropTypes.shape({
        language: PropTypes.string,
        pathPrefix: PropTypes.string,
        isCurrent: PropTypes.bool,
    })),
};
LanguageSwitch.defaultProps = {
    languages: [],
};
export default LanguageSwitch;
var templateObject_1, templateObject_2;
